import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
})
export class IframeComponent implements OnInit {
  @Input() paymentType;
  source
  buttonLoading=false
  messages=[]
  body_css = [
    'font-family:"Segoe UI",Roboto,"Helvetica Neue",Arial',    'margin:15px',    'box-sizing:content-box',    'font-size:16px',    'background:white',    'padding:0px',
  ].join(';');
  input_label_css =[
    'display:block',
  ].join(';');
  input_css =[
    'border:1px solid rgb(206, 212, 218)',    'padding: .375rem .75rem',    'margin: .375rem 0px 1rem',    'font-family: inherit',    'border-radius: .25rem',    'height: calc(1.5em + .75rem + 2px)',    'font-size: 1rem',    'width:80%',
  ].join(';');
  input_pan_css = [
    'width:100%',
  ].join(';')
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private toastSRV:ToastService,
    private sanitizer:DomSanitizer,
    public dataSRV:DataService,
    private translate: TranslateService,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.source = this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentType['url']+'?id='+ this.paymentType['hosted_token'] +'&pmmsg=true&css_body=' + this.body_css + '&css_textbox='+ this.input_css+'&css_textbox_pan='+this.input_pan_css+'&enable_exp=1&css_textbox_exp=width:40%;padding:0.5em;margin:0.3em 0;&css_textbox_cvd=width:40%;&enable_cvd=1&enable_exp_formatting=1&enable_cc_formatting=1&display_labels=1&pan_label='+this.translate.instant('keys.data.payments.card_number')+'&exp_label='+this.translate.instant('keys.data.payments.card_expiry')+'&cvd_label=' + this.translate.instant('keys.data.payments.cvv'));
    if (window.addEventListener) 
                    {  
                      window.onmessage= response=> {
                        if (response?.data) {
                          // $('#monerisHostedTokenMessages').empty();
                          try {
                            this.messages=[]
                              let data = JSON.parse(response.data);
                              // bin: "476173"
                              // dataKey: "ot-s7yTxQ4QEJ0uVfBoBm9gs1Fj3"
                              if (data?.responseCode == '001') {
                                this.dataSRV.postData('account/subscriptions/creditcard/add?cardType=' + this.paymentType['PaymentTypeID'],
                                {
                                  // 'data': data,
                                  'dataKey': data?.dataKey ?? '--',
                                  'bin': data?.bin ?? '--',
                                  'status': 'success'
                              }).subscribe({
                                next:resData=>{
                                  if(resData['status']=='success'){
                                    this.toastSRV.presentToast(resData['message'])
                                    this.buttonLoading=false
                                    this.modalCtrl.dismiss('reload')
                                  } else {
                                    this.buttonLoading=false
                                    this.errorHandlerSRV.displayErrorMessage(resData,true)
                                  }
                                },
                                error:error=>{
                                  this.buttonLoading=false
                                  this.errorHandlerSRV.displayErrorMessage(error,true)
                                }
                                
                               
                              })
                                 
                                  return false; // abort to prevent iframe from returning.
                              } else {
                                this.buttonLoading=false
                                  let errorCodes = data?.responseCode;
                                  
                                  let other_used = false;
                                  errorCodes.forEach(code =>{
                                      switch (code) {
                                          case '942':
                                              this.messages.push(this.translate.instant('keys.data.payments.invalid_credentials'));
                                              break;
                                          case '943':
                                              this.messages.push(this.translate.instant('keys.data.payments.invalid_card'));
                                              break;
                                          case '944':
                                              this.messages.push(this.translate.instant('keys.data.payments.invalid_expiry'));
                                              break;
                                          case '945':
                                              this.messages.push(this.translate.instant('keys.data.payments.invalid_cvd'));
                                              break;
                                          default:
                                              if (!other_used) {
                                                  other_used = true;
                                                  this.messages.push(this.translate.instant('keys.data.errors.unknown'))
                                              }
                                      }
                                  });
                                  
                                  
                              }
                          } catch (e) {
                          }
                      }
                        
                      };
                                  
                    }
                    else 
                    {
                     
                     }
  
  }
  doMonerisSubmit(){
    var htmlref=document.getElementById('monerisFrame') as HTMLIFrameElement
    var monFrameRef = htmlref.contentWindow;
    monFrameRef.postMessage('tokenize','https://esqa.moneris.com/HPPtoken/index.php');
    this.buttonLoading=true
    
    return false;
}


}
